export const updateNotificationCount = (dispatch, count) => dispatch({ type: 'NOTIFICAION_COUNT', count });

export const reduceNotificationCount = (dispatch) => dispatch({ type: 'REDUCE_NOTIFICAION_COUNT' });
